import React, { useState } from "react";
import { FaSpinner } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import Input from "../../components/input";
import useAxiosInstance from "../../hooks/useAxios";
import JsonView from "@uiw/react-json-view";

const TaskRestarter = () => {
  const [paramterType, setParameterType] = useState("");
  const [taskId, setTaskId] = useState("");
  const [reportId, setReportId] = useState("");
  const [data, setData] = useState("");
  const axios = useAxiosInstance();
  const [isLoading,setIsLoading] = useState(false);

  const handleSubmit = () => {
    let data = {};
    if (paramterType === "taskId") {
      data = {
        task_id: taskId,
      };
    } else if (paramterType === "reportId") {
      data = {
        report_id: reportId,
      };
    }
    setIsLoading(true)
    setData("")
    axios
      .post("/assets/task_restart/", data)
      .then((res) => {
        toast.info(res.data.status);
        console.log(data);
        console.log(res.data);
        setIsLoading(false)
        setData(JSON.stringify(res.data));
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false)
      });
  };
  return (
    <div
      className={`h-screen w-full justify-center p-5  overflow-y-auto ${
        "items-start"
      } flex`}
    >
        <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
          <p className="text-2xl font-semibold mb-4">Task Restarter</p>
          <div className="text-sm font-semibold mb-2">Paramter Type</div>
          <select
            value={paramterType}
            onChange={(e) => {
              setReportId("");
              setTaskId("");
              setParameterType(e.target.value);
            }}
            className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
            placeholder="Enter your password"
          >
            <option value={""}>Choose</option>
            <option value={"taskId"}>Task Id</option>
            <option value={"reportId"}>Report Id</option>
          </select>

          {paramterType === "taskId" && (
            <div>
              <div className="text-sm font-semibold mb-2 mt-4">Task Id</div>
              <Input
                value={taskId}
                onChange={(e) => {
                  setTaskId(e.target.value);
                }}
                placeholder="Enter the Task Id"
              />
            </div>
          )}

          {paramterType === "reportId" && (
            <div>
              <div className="text-sm font-semibold mb-2 mt-4">Report Id</div>
              <Input
                value={reportId}
                onChange={(e) => {
                  setReportId(e.target.value);
                }}
                placeholder="Enter the Report Id"
              />
            </div>
          )}

          <button
            disabled={
              isLoading||
              paramterType === "" ||
              (paramterType === "taskId" && taskId === "") ||
              (paramterType === "reportId" && reportId === "")
            }
            className="bg-black disabled:bg-[#B6b6b6] disabled:text-white disabled:cursor-not-allowed text-white py-3 hover:shadow-lg  text-center w-full rounded-lg mt-4"
            type="button"
            onClick={() => {
              handleSubmit();
            }}
          >
            {!isLoading? 'Submit':'Loading'} 
          </button>

          {data ? <>  
          <p className="mt-3 mb-3">Output:</p>  
          <pre>{data}</pre></>:null}
        </div>
    </div>
  );
};

export default TaskRestarter;
